import { ca } from '@cian/analytics';

export const trackShowOnCommonFilter = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Newbuilding_chat_shown',
    label: 'common_filter',
  });
};

export const trackOpenedOnCommonFilter = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Newbuilding_chat_opened',
    label: 'common_filter',
  });
};
